// Layout estándar para páginas que no son register: container > row >
// columna centrada, con el título de la página y el banner de mensaje
// si lo hay. Las páginas register tienen su propio layout fluid (con
// quality seal y demás bloques de marketing) y NO usan StandardPage.

import type { ReactNode } from "react";
import type { KcData } from "../kcData";
import { Message } from "./Message";
import { pageTitle } from "../pageTitles";

export interface StandardPageProps {
  page: string;
  data: KcData;
  // Título ya resuelto por Keycloak (p. ej. el messageHeader de `info`);
  // sin él, el de pageTitles.
  title?: string;
  children?: ReactNode;
}

export function StandardPage({ page, data, title, children }: StandardPageProps) {
  // Las pantallas `error` y `info` pintan ellas mismas el summary del
  // mensaje (con un layout propio), así que evitamos duplicarlo aquí.
  const showMessage = page !== "error" && page !== "info";

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4 col-md-offset-4 text-center">
          <h3>{title || pageTitle(page)}</h3>
          {showMessage ? <Message message={data.message} /> : null}
          {children}
        </div>
      </div>
    </div>
  );
}
